import { render, staticRenderFns } from "./DoctorNotificationDropDown.vue?vue&type=template&id=0b40e6a7&"
import script from "./DoctorNotificationDropDown.vue?vue&type=script&lang=js&"
export * from "./DoctorNotificationDropDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports